import axios from 'axios';
import generateUniqueId from 'generate-unique-id';
import * as constant from './constants';
import { storeItem, retrieveItem } from '../Functions';
import { generateCorrelationId } from '../Functions';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL_V2 = process.env.REACT_APP_BASE_URL_V2;
const BASE_URL_V3 = process.env.REACT_APP_BASE_URL_V3;
const APP_TOKEN = process.env.REACT_APP_TOKEN;
const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER;

const axiosOrders = (version: string = 'v1') => {
  const versionObj: Record<any, string | undefined> = {
    v1: BASE_URL,
    v2: BASE_URL_V2,
    v3: BASE_URL_V3,
  };
  const instance = axios.create({
    baseURL: versionObj?.[version] ?? BASE_URL,
    headers: {
      'app-token': APP_TOKEN,
      language: 'en',
      'build-number': BUILD_NUMBER,
      source: 'fe-web-app',
    },
  });

  instance.interceptors.request.use(
    async config => {
      const authToken = config.headers[constant.ApiHeaders.AuthToken];
      const deviceId = config.headers[constant.ApiHeaders.DeviceId];
      const correlationId = config.headers[constant.ApiHeaders.XCorrelationId];
      if (!authToken) {
        const savedAuthToken = await retrieveItem(constant.StorageKeys.AuthToken);
        config.headers[constant.ApiHeaders.AuthToken] = savedAuthToken;
      }
      if (!deviceId) {
        const savedDeviceId = await retrieveItem(constant.StorageKeys.DeviceId);
        if (savedDeviceId) {
          config.headers[constant.ApiHeaders.DeviceId] = savedDeviceId;
        } else {
          const id = generateUniqueId({
            length: 36,
            useLetters: true,
            useNumbers: true,
            includeSymbols: ['-'],
          });
          storeItem(constant.StorageKeys.DeviceId, id);
          config.headers[constant.ApiHeaders.DeviceId] = id;
        }
      }
      if (!correlationId) {
        const id = generateCorrelationId();
        config.headers[constant.ApiHeaders.XCorrelationId] = id;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosOrders;
